import { h, render } from 'preact';
import { FlowButton } from './flowButton.component';
import { ButtonLayout } from '../containers/buttonLayout.container';
import { ViewHeadline } from './viewHeadline.component';
import { StepCounter } from './stepCounter.component';

export function RetainedAttorney() {
  const pageHeader = {
    headline: 'Is an attorney already helping you with your claim?'
  };

  const progressChild = (
    <StepCounter
      currentStep={8}
      totalSteps={11} />
  );

  const headlineChild = (
    <ViewHeadline {...pageHeader} />
  );

  const modelProp = 'retainedAttorney';
  const nextUrl = 'accident-state';

  const btnData = [
    {
      to: nextUrl,
      modelVal: 'Yes',
      modelProp,
      buttonText: 'Yes',
      component: FlowButton
    },
    {
      to: nextUrl,
      modelVal: 'No',
      modelProp,
      buttonText: 'No',
      component: FlowButton
    }
  ];

  return (
    <ButtonLayout
      headlineChild={headlineChild}
      progressChild={progressChild}
      btnData={btnData} />
  );
}
